import { TRACK_THIS_PAGE_VIEW } from '../../../constants';
export const pageViewInitializer = item => {
  // Disable automatic `pageView` tracking to prevent `pageView` from being sent multiple times
  // when using @ori/logger multiple times on the same page, e.g. in Client Apps.
  if (item.baseType === 'PageviewData' && !item.data?.[TRACK_THIS_PAGE_VIEW]) {
    return false;
  }
  return true;
};
//# sourceMappingURL=pageViewInitializer.js.map